import { InjectionToken } from '@angular/core';

export const GSAP_SCROLLTRIGGER_OPTIONS = new InjectionToken<Partial<gsap.plugins.ScrollTriggerInstanceVars>>('GSAP ScrollTrigger options');
